<template>
  <div>
    <div>
      <h2>Search and add a pin</h2>
          <!-- <GmapAutocomplete
        @place_changed='setPlace'
      />
      <button
        @click='addMarker'
      >
        Add
      </button> -->
    </div>
    <br>
    <GmapMap
      :center='center'
      :zoom='12'
      style='width:90%;  height: 500px;'
    >
    <gmap-polygon :paths="paths"></gmap-polygon>
    <GmapMarker
        :key="index"
        v-for="(m, index) in markers"
        :position="m.position"
        @click="center=m.position"
      />
    </GmapMap>
  </div>
</template>

<script>
import {gmapApi} from 'vue2-google-maps'
export default {
  name: 'GoogleMap',
  computed: {
    google: gmapApi
  },
    data() {
    return {
      center: {lat: 45.508, lng: -73.587},
    //   currentPlace: null,
    //   markers: [],
    //   places: [],
    poly:[],
    paths: [ ]
    }
  },
   mounted() {
    this.geolocate();
    // this.addPolygon();
  },
  methods: {
    addPolygon(){
        this.poly = new this.google.maps.Polygon({
        paths: this.paths,
        strokeColor: '#FF0000',
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: '#FF0000',
        fillOpacity: 0.35
      });
      console.log(this.poly);
      this.$refs.mapRef.$mapPromise.data.add({geometry: new this.google.maps.Data.Polygon([this.poly])});
    },
    geolocate: function() {
      navigator.geolocation.getCurrentPosition(position => {
        this.center = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };
      });
    },
    setPlace(place) {
        console.log("any",place)
      this.currentPlace = "kalyanpur";
    },
    addMarker() {
        console.log("hello")
      if (this.currentPlace) {
        const marker = {
          lat: this.currentPlace.geometry.location.lat(),
          lng: this.currentPlace.geometry.location.lng(),
        };
        this.markers.push({ position: marker });
        this.places.push(this.currentPlace);
        this.center = marker;
        this.currentPlace = null;
      }
    },
  },
}
</script>